import React from 'react';
import {StyleSheet, View} from 'react-native';
import Text from '@/components/basic/text';
import theme from '@/style';
import {COLORS} from '../constant';

export interface BetsLabelProps {
  type: 'A' | 'B' | 'C' | 'D';
}

const BetsLabel = ({type}: BetsLabelProps) => {
  if (typeof document !== 'undefined') {
    return (
      <div style={stylesWeb.wrap}>
        <span style={{...stylesWeb.text, color: COLORS[type]}}>{type}</span>
        <div style={{...stylesWeb.dot, backgroundColor: COLORS[type]}} />
      </div>
    );
  }

  return (
    <View style={[styles.wrap, theme.padding.rightl]}>
      <Text color={COLORS[type]} size="large" fontFamily="fontInterBold">
        {type}
      </Text>
      <View style={[styles.dot, {backgroundColor: COLORS[type]}]} />
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    width: 16,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 16,
  },
  dot: {
    width: 16,
    height: 16,
    borderRadius: 8,
    marginTop: 6,
  },
});

const stylesWeb: Record<string, React.CSSProperties> = {
  wrap: {
    width: '1rem',
    marginRight: '1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  text: {
    fontSize: '1rem',
    lineHeight: '1.25rem',
    fontWeight: 500,
    fontFamily: 'Inter-Bold',
  },
  dot: {
    width: '0.875rem',
    height: '0.875rem',
    marginTop: '0.3125rem',
    borderRadius: '9999px',
  },
};

export default BetsLabel;
